import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { Colors } from 'styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Icon } from 'common/ui/Icon';
import { css } from 'styled-components';
import { StatusIndicator } from 'domains/reporter/Reporter/Toolbars/ReportToolbar/StatusIndicator';
import { ReportSignedByLabel } from './ReportSignedByLabel';
import { logger } from 'modules/logger';
import { ReporterSaveStateType } from 'config/recoilState';

type UnifiedEditorTopBarProps = {
  isFocusModeSettingOn: boolean;
  toggleFocusMode: () => void;
  isFocusModeOn: boolean;
  label?: string | null;
  isReportEditor: boolean;
  saveStatus: ReporterSaveStateType;
  lastUpdated?: Date | null;
  reportOwner?: { firstName: string; lastName: string } | null;
  reportSentAt?: Date | null;
  isAddendumEditor: boolean;
  shouldShowFocusModeToggle: boolean;
  shouldShowStatusIndicator: boolean;
  shouldShowTemplateName: boolean;
  templateName: string | undefined;
};

export const UnifiedEditorTopBar = ({
  isFocusModeSettingOn,
  toggleFocusMode,
  isFocusModeOn,
  label,
  isReportEditor,
  saveStatus,
  lastUpdated,
  reportOwner,
  reportSentAt,
  isAddendumEditor,
  shouldShowFocusModeToggle,
  shouldShowStatusIndicator,
  shouldShowTemplateName,
  templateName,
}: UnifiedEditorTopBarProps) => {
  return (
    <Stack
      alignX={isFocusModeSettingOn || shouldShowTemplateName || label != null ? 'between' : 'end'}
      alignY="center"
      css={css`
        margin-bottom: 2px !important;
      `}
    >
      {label != null && (
        <Text variant="body1" color={Colors.gray8}>
          {label}
        </Text>
      )}
      <Stack>
        {isFocusModeSettingOn && shouldShowFocusModeToggle && (
          <FormControlLabel
            data-testid="focus-mode-form-input"
            control={
              <Switch
                color="primary"
                size="small"
                onChange={() => {
                  logger.info('Focus mode toggled via form control');
                  toggleFocusMode();
                }}
              />
            }
            label={
              <Stack css={{ marginLeft: 16 }} alignY="center" space="xxsmall">
                <Icon name="focusMode" css="width: 16px; height: 16px;" />
                <Text variant="body2">Focus Mode</Text>
              </Stack>
            }
            labelPlacement="start"
            checked={isFocusModeOn}
          />
        )}
        {shouldShowTemplateName && (
          <Text
            variant="display1"
            color={Colors.gray8}
            css={css`
              margin-left: 16px;
            `}
          >
            Template: {templateName == null ? 'Sirona Default' : templateName}
          </Text>
        )}
      </Stack>

      <Stack
        alignX="center"
        alignY="center"
        css={css`
          margin-right: 2px;
          ${isReportEditor ? 'height: 16px;' : ''}
        `}
      >
        {shouldShowStatusIndicator && (
          <div data-testid="status-indicator-wrapper">
            <StatusIndicator status={saveStatus} lastUpdated={lastUpdated} />
          </div>
        )}
        {!shouldShowStatusIndicator && reportSentAt != null && !isAddendumEditor && (
          <ReportSignedByLabel
            firstName={reportOwner?.firstName}
            lastName={reportOwner?.lastName}
            sentAt={reportSentAt}
          />
        )}
      </Stack>
    </Stack>
  );
};
